import Swiper from "swiper"
import { Autoplay, Pagination, Navigation } from "swiper/modules"

Swiper.use([Autoplay, Pagination, Navigation])

const defaultConfig = {
  slidesPerView: 1,
  loop: true,
  speed: 1000,
  pagination: {
    clickable: true,
    el: ".swiper-pagination",
    type: "bullets",
  },
  navigation: {
    addIcons: false,
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  observer: true,
  observeParents: true,
}

const collectionsConfig = {
  ...defaultConfig,
  loop: false,
  spaceBetween: 30,
  slideToClickedSlide: true,
  breakpoints: {
    0: {
      slidesPerView: 1.2,
      pagination: {
        enabled: true,
      },
      allowTouchMove: true,
    },
    800: {
      slidesPerView: 2.2,
      pagination: {
        enabled: true,
      },
      allowTouchMove: true,
    },
    1100: {
      slidesPerView: 3.2,
      pagination: {
        enabled: true,
      },
      allowTouchMove: true,
    },
    1366: {
      slidesPerView: 4,
      loopedSlides: 4,
      pagination: {
        enabled: false,
      },
      allowTouchMove: false,
    },
  },
}

const howToConfig = {
  ...defaultConfig,
  loop: false,
  slideToClickedSlide: true,
  breakpoints: {
    0: {
      slidesPerView: 1.35,
      spaceBetween: 0,
      pagination: {
        enabled: false,
      },
      allowTouchMove: true,
    },
    992: {
      slidesPerView: 3,
      loopedSlides: 3,
      spaceBetween: 48,
      pagination: {
        enabled: false,
      },
      allowTouchMove: false,
    },
    1366: {
      slidesPerView: 3,
      loopedSlides: 3,
      spaceBetween: 96,
      pagination: {
        enabled: false,
      },
      allowTouchMove: false,
    },
  },
}

const heroConfig = {
  ...defaultConfig,
  speed: 2000,
  autoplay: {
    delay: 6000,
    disableOnInteraction: false,
  },
}

const productsConfig = {
  ...defaultConfig,
  loop: false,
  slideToClickedSlide: true,
  pagination: {
    enabled: false,
  },
  breakpoints: {
    0: {
      slidesPerView: 1.18,
      spaceBetween: 24,
      slidesOffsetBefore: 20,
      slidesOffsetAfter: 20,
      allowTouchMove: true,
    },
    992: {
      slidesPerView: 3,
      spaceBetween: 48,
      slidesOffsetBefore: 0,
      slidesOffsetAfter: 0,
      allowTouchMove: false,
    },
  },
}

const stepsConfig = {
  ...defaultConfig,
  loop: false,
  slideToClickedSlide: true,
  pagination: {
    enabled: false,
  },
  breakpoints: {
    0: {
      slidesPerView: 1.25,
      spaceBetween: 24,
      slidesOffsetBefore: 24,
      slidesOffsetAfter: 24,
      allowTouchMove: true,
    },
    992: {
      slidesPerView: 4,
      spaceBetween: 48,
      slidesOffsetBefore: 0,
      slidesOffsetAfter: 0,
      allowTouchMove: false,
    },
    1366: {
      slidesPerView: 4,
      spaceBetween: 80,
      slidesOffsetBefore: 0,
      slidesOffsetAfter: 0,
      allowTouchMove: false,
    },
  },
}

const testimonialsConfig = {
  ...defaultConfig,
  spaceBetween: 12,
  loop: false,
  rewind: true,
  slideToClickedSlide: true,
  breakpoints: {
    0: {
      slidesPerView: 1.3,
      pagination: {
        enabled: true,
      },
      allowTouchMove: true,
    },
    700: {
      slidesPerView: 2.5,
      spaceBetween: 24,
      pagination: {
        enabled: true,
      },
      allowTouchMove: true,
    },
    1000: {
      slidesPerView: 3.5,
      spaceBetween: 36,
    },
    1440: {
      slidesPerView: 4.5,
      spaceBetween: 36,
      pagination: {
        enabled: true,
      },
    },
  },
}

function getConfig(type) {
  if (type === "collections") {
    return collectionsConfig
  }

  if (type === "how-to") {
    return howToConfig
  }

  if (type === "hero") {
    return heroConfig
  }

  if (type === "products") {
    return productsConfig
  }

  if (type === "steps") {
    return stepsConfig
  }

  if (type === "testimonials") {
    return testimonialsConfig
  }

  return defaultConfig
}

;(() => {
  function initSwiper() {
    const elements = document.querySelectorAll(".swiper-container")

    for (const element of elements) {
      new Swiper(element, getConfig(element.dataset.swiperConfig))
    }
  }

  window.addEventListener("load", () => {
    initSwiper()
  })
})()
